import { render, staticRenderFns } from "./MarkdownViewer.vue?vue&type=template&id=5fc26586&scoped=true"
import script from "./MarkdownViewer.vue?vue&type=script&lang=js"
export * from "./MarkdownViewer.vue?vue&type=script&lang=js"
import style0 from "./MarkdownViewer.vue?vue&type=style&index=0&id=5fc26586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc26586",
  null
  
)

export default component.exports